/** function for generate errors from BE for assign tariffs to wallbox */
export const assignTariffApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  TARIFF_INSTALLATION_NOT_FOUND: 'emobility.api-errors.tariff-installation-not-found',
  TARIFFS_VALIDITY_PERIODS_OVERLAP: 'emobility.api-errors.tariff-validity-periods-overlap',
  TARIFF_ALREADY_LINKED: 'emobility.api-errors.tariff-already-linked',
  CONNECTOR_DOES_NOT_EXISTS_ON_WALLBOX: 'emobility.api-errors.connector-does-not-exists-on-wallbox',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TARIFF_NOT_FOUND: 'emobility.api-errors.tariff-not-found',
  INSTALLATION_NOT_FOUND: 'emobility.api-errors.installation-no-found',
  CONNECTOR_NOT_FOUND: 'emobility.api-errors.connector-no-found',
  WALLBOX_NOT_FOUND: 'emobility.api-errors.wallbox-no-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  EVSE_ID_NOT_FOUND: 'emobility.api-errors.evse-not-found',
  EXPIRED_TARIFF_CAN_NOT_BE_ASSIGN: 'emobility.api-errors.expired-tariff-assignment',
}

/** function for generate errors from BE for unassign token to wallbox */
export const unAssignTokenApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TOKEN_LINK_NOT_FOUND: 'emobility.api-errors.token-link-not-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  WALLBOX_NOT_ASSIGNED: 'emobility.api-errors.wallbox-no-assigned',
  EVSE_ID_NOT_FOUND: 'emobility.api-errors.evse-not-found',
}
